import { TYPE } from './config.json';

export default () => {

	if (TYPE === 'test') {
		return "http://63.34.128.11/api/snapfix";
	} else {
		return "https://api.snapfix.io/api/snapfix";
	}
}
//https://api.snapfix.io/api/snapfix/index.php?action=save_image
//"https://puzhvyehgk.execute-api.eu-west-1.amazonaws.com/live/webappadmin/legacy"